import '../assets/scss/components/optiontile.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useState, useEffect, useRef, useContext } from 'react';
import { EmbedSiteShortContext } from '../App.js';
import * as API from '../api/Service.js'
import Alert from 'react-bootstrap/Alert';
import Carousel from './common/Carousel.jsx';
import { useErrorBoundary } from "react-error-boundary";

export default function OptionTile(props)
{

    //console.log("OptionTile " + props.optionModel.productName, props);

    const site = useContext(EmbedSiteShortContext);

    // Handle option spec fetch
    let [productSpecModel, setProductSpecModel] = useState(null);
    let url = "/product/details?productID=" + props.optionModel?.optionProductID ?? 0;
    const fetchProductSpecRefetch = API.useRefetchQuery("fetchProductSpecRefetch" + props.optionModel?.optionProductID ?? 0, url, 1);

    const { showBoundary } = useErrorBoundary();

    const handleInfoClicked = (e) =>
    {
        e.stopPropagation();

        // add page to history to cater for mobile user hitting back button to hide slide out panel
        window.history.pushState({ modalOpen: true }, '');

        fetchProductSpecRefetch()
            .then((response) =>
            {
                if (response?.data?.errors && Object.keys(response.data.errors).length > 0)
                {
                    throw new Error(JSON.stringify(response));
                }

                return response.data;
            })
            .then((refetchData) =>
            {
                setProductSpecModel(refetchData);
                return true; // call finished
            })
            .catch((error) =>
            {
                //console.log("OptionTile fetchProductSpecRefetch error: ", JSON.parse(JSON.stringify(error)));
                showBoundary(error);
            });
    }

    const offcanvasCloseBtnRef = useRef(null);
    const hiddenOffcanvasCloseBtnRef = useRef(null);
    const offcanvasElementRef = useRef(null);
    const otListItemWrapperRef = useRef(null);

    useEffect(() => {

        const handlePopstate = (event) => {

            if (offcanvasElementRef.current && offcanvasElementRef.current.classList.contains("show")) 
            {
                hiddenOffcanvasCloseBtnRef.current.click();
            }
        };

        // Add event listener for popstate when the component mounts
        window.addEventListener('popstate', handlePopstate);


        const handleMimicPopstate = (event) => {
            window.history.back();           
        };
        
        const handleMimicPopstateAlt = (event) => {
            if (event.target && event.target.matches('.offcanvas-backdrop.fade')) {
                window.history.back();           
            }        
        };

        const offfcanvasCloseBtnEl = offcanvasCloseBtnRef.current;
        const otListItemWrapperEl = otListItemWrapperRef.current;

        // mimc popstate for close button + grey overlay
        if (offfcanvasCloseBtnEl) {
            offfcanvasCloseBtnEl.addEventListener('click', handleMimicPopstate);
        }

        if (otListItemWrapperEl) {
            otListItemWrapperEl.addEventListener('click', handleMimicPopstateAlt);
        }

        // Clean up the event listener when the component unmounts
        return () => {
            window.removeEventListener('popstate', handlePopstate);

            if (offfcanvasCloseBtnEl) {
                offfcanvasCloseBtnEl.removeEventListener('click', handleMimicPopstate);
            }
            
            if (otListItemWrapperEl?.children[1]) {
                otListItemWrapperEl.children[1].removeEventListener('click', handleMimicPopstateAlt);
            }
        };

    }, []);

    // Option deselection failure
    let [showDeselectLocked, setShowDeselectLocked] = useState(false);

    useEffect(() => {
        if (showDeselectLocked)
        {
            setTimeout(function() {
                setShowDeselectLocked(false);
            } , 350);
        }
    });

    // move ATB btn to bottom when it scrolls off top of panel
    const atbBtnRef = useRef(null);
    const offcanvasBodyRef = useRef(null);

    useEffect(() => {

        const offcanvasBodyEl = offcanvasBodyRef.current;

        const handleScroll = () => {
            const scrollY = offcanvasBodyEl.scrollTop;
            const containerHeight = offcanvasBodyEl.children[0].clientHeight + 48 + offcanvasBodyEl.children[1].clientHeight + 24; // magic no.s are margin sizes
            const contentHeight = offcanvasBodyEl.children[2].scrollHeight;

            if (scrollY >= containerHeight) 
            {
                atbBtnRef.current.style.position = 'relative';
                atbBtnRef.current.style.top = contentHeight + 80 + "px"; // 48px is extra margin
                offcanvasBodyEl.children[2].style.marginBottom = 36 + "px";
            } 
            else 
            {
                atbBtnRef.current.style.position = 'static';
            }
        };

        offcanvasBodyEl.addEventListener('scroll', handleScroll);

        // Clean up the event listener when the component is unmounted
        return () => {
            if (offcanvasBodyEl)
            {
                offcanvasBodyEl.removeEventListener('scroll', handleScroll);
            }
        };
    }, []);

    // UI and Event handlers
    if (!props.optionModel) return null;

    // UI setup
    let priceDifferenceSign = props.optionModel.grossPriceDifference < 0 ? "-" : "+";
    let textColour = site === "chillblast" ? "text-muted custom-color-light" : "text-light";

    //#region Event Handlers

    const handleImageLoaded = () =>
    {
        var requiredLoadedCategories = props.requiredLoadedCategories.current;

        if (requiredLoadedCategories != null && props.loadingCategoryName != null) {
            if (requiredLoadedCategories.length > 0) {
                var categoryIndex = requiredLoadedCategories.findIndex(x => x.name === props.loadingCategoryName);
                if (categoryIndex > -1) {
                    requiredLoadedCategories.splice(categoryIndex, 1);
                }
            } else {
                props.imageLoaded.current = true;
                requiredLoadedCategories.current = null;
            }
        }
    }

    const handleOptionClicked = () =>
    {
        if (props.isDisabled) 
            return; 
                               
        let success = props.handleOptionSelected(props.optionModel.optionProductID, props.optionModel.selectedQuantity, false, !props.optionModel.isSelected, props.isIncompatible); 

        if (!success)
            setShowDeselectLocked(true);
    }

    //#endregion Event Handlers

    //console.log("product spec model: ", productSpecModel);
    //console.log(props.loadingCategoryName + " props.displayType: ", props.displayType);

    // 18/08
    // don't forget tag stuff

    return (
        <div ref={otListItemWrapperRef} className="h-100">
            {
                props.displayType === 1 // narrow long
                ?
                    <div className={"ot-card ot-card-narrow-long card rounded-0 justify-content-center px-2 h-100 py-3"  + (props.isIncompatible ? " incompatible " : "") + (props.optionModel.isSelected ? " product-selected" : "") + (props.isDisabled ? " disabled" : "") + (!showDeselectLocked ? "" : " lock-toast")}
                        onClick={ handleOptionClicked }
                    >

                        <div className="hstack gap-2 align-items-center justify-content-center">
                            <img onLoad={handleImageLoaded} src={props.settings.imageBaseUrl + props.optionModel.imageUrl + "?width=32&height=32&scale=both"} className="product-image p-1" alt={props.optionModel.productName}></img>

                            <div className={site === "ccl" ? "vstack gap-2" : "hstack gap-2 w-100"}>

                                <div className={"product-name-container w-100" + (!props?.optionModel?.summaryList ? " wide-product-name" : "")}>
                                    <h5 className={"product-name m-0 custom-color-light"}>{props.optionModel.productName}</h5>
                                </div>
                                
                                {
                                    props.optionModel.tagText
                                    &&
                                    <span style={{ backgroundColor: props.optionModel.tagColour, border: props.optionModel.tagColour + " 2px solid" }} className={"product-tag-container text-start px-2 "}>
                                        <label className={"product-tag mb-0 " + textColour}>{props.optionModel.tagText}</label>
                                    </span>
                                }

                                <div className={"product-summary-container overflow-hidden flex-fill" + (!props?.optionModel?.summaryList ? " d-none" : "")}>
                                    <label className={"product-summary cursor-pointer" + (!props.optionModel.isSelected ? " text-white" : props.optionModel.isSelected && site === "ccl" ? " text-muted-light" : " text-muted-light")}>
                                        {
                                            props?.optionModel?.summaryList?.length > 0
                                            &&
                                                props.optionModel.summaryList.map((feature, index) =>
                                                    <div key={"spanFeature_" + index}>
                                                        {feature}
                                                    </div>
                                                )
                                        }
                                    </label>
                                </div>
                            </div>


                            <div className="product-price-container vstack gap-2 align-items-end">
                                <span className={"product-price d-inline-flex justify-content-end " + textColour + (props.optionModel.isSelected && props.allowQuantitySelection ? "" : "")}>
                                    {
                                        props.optionModel.isSelected && props.allowQuantitySelection
                                        ?
                                            <span className="quantity-selector-container py-0">
                                                <span className="quantity-selector-sign mx-1" onClick={(e) => { e.stopPropagation(); if (props.isDisabled) return; props.handleOptionSelected(props.optionModel.optionProductID, props.optionModel.selectedQuantity - 1, true, true); }}>
                                                    <FontAwesomeIcon icon={icon({ name: 'minus', style: 'solid' })} />
                                                </span>
                                                <span className="quantity-selector-number">
                                                    {props.optionModel.selectedQuantity}
                                                </span>
                                                <span className="quantity-selector-sign mx-1" onClick={(e) => { e.stopPropagation(); if (props.isDisabled) return; props.handleOptionSelected(props.optionModel.optionProductID, props.optionModel.selectedQuantity + 1, true, true); }}>
                                                    <FontAwesomeIcon icon={icon({ name: 'plus', style: 'solid' })} /> 
                                                </span>
                                            </span>
                                        :
                                        props.optionModel.isSelected
                                        ?
                                            "Selected"
                                        :
                                        props.allowMultipleSelection
                                        ?
                                            <span className="product-price-value">&pound;{Math.abs(props.optionModel.grossPrice).toFixed(2)}</span>
                                        :
                                            <span className="product-price-value">{priceDifferenceSign} &pound;{Math.abs(props.optionModel.grossPriceDifference).toFixed(2)}</span>
                                    }
                                </span>

                                <span className={"info-container mt-auto " + textColour}>
                                    <button className={"position-relative bg-transparent border-0 pe-0 " + textColour} type="button"
                                        data-bs-toggle="offcanvas" data-bs-target={"#offcanvasProduct_" + props.optionModel.optionProductID} aria-controls={"#offcanvasProduct_" + props.optionModel.optionProductID}
                                        onClick={handleInfoClicked}
                                    >
                                        <span className="me-1">Info</span>
                                        <FontAwesomeIcon icon={icon({ name: 'circle-info', style: 'solid' })} />
                                    </button>
                                </span>
                            </div>

                            
                        </div>


                    </div>
                :
                props.displayType === 2 // big image
                ?
                    <div className={"ot-card card rounded-0 p-2 h-100" + (props.isIncompatible ? " incompatible " : "") + (props.optionModel.isSelected ? " product-selected" : "") + (props.isDisabled ? " disabled" : "") + (!showDeselectLocked ? "" : " lock-toast")}
                    onClick={ handleOptionClicked }
                    >

                        <img onLoad={handleImageLoaded} src={props.settings.imageBaseUrl + props.optionModel.imageUrl + "?width=300&height=300&scale=both"} className={"product-image img-fluid p-1"} alt={props.optionModel.productName}></img>

                        <div>
                            <h5 className={"product-name mt-1 mb-0 mt-sm-2 mb-sm-1 " + textColour}>{props.optionModel.productName}</h5>
                        </div>

                        <span style={{ backgroundColor: props.optionModel.tagColour, border: props.optionModel.tagColour + " 2px solid" }} className={"product-tag-container text-start px-2 "}>
                            <label className={"product-tag mb-0 " + textColour}>{props.optionModel.tagText}</label>
                        </span>
                        
                        <div className="d-flex justify-content-between align-items-center mt-auto">
                            <div>
                                <span className={"product-price " + textColour}>
                                    {
                                        props.optionModel.isSelected
                                        ?
                                            "Selected"
                                        :
                                            props.allowMultipleSelection
                                            ?
                                                <span>&pound;{Math.abs(props.optionModel.grossPrice).toFixed(2)}</span>
                                            :
                                                <span>{priceDifferenceSign} &pound;{Math.abs(props.optionModel.grossPriceDifference).toFixed(2)}</span>
                                    }
                                </span>
                            </div>

                            <span className={"position-relative text-end text-muted " + textColour}>
                                <button className={"position-relative bg-transparent border-0 text-muted " + textColour} type="button"
                                    data-bs-toggle="offcanvas" data-bs-target={"#offcanvasProduct_" + props.optionModel.optionProductID} aria-controls={"#offcanvasProduct_" + props.optionModel.optionProductID}
                                    onClick={handleInfoClicked}
                                >
                                    <span className="me-1">Info</span>
                                    <FontAwesomeIcon icon={icon({ name: 'circle-info', style: 'solid' })} />
                                </button>
                            </span>
                        </div>

                    </div>
                :
                props.displayType === 3 // balanced
                &&
                    <div className={"ot-card card rounded-0 p-2 h-100" + (props.isIncompatible ? " incompatible " : "") + (props.optionModel.isSelected ? " product-selected" : "") + (props.isDisabled ? " disabled" : "") + (!showDeselectLocked ? "" : " lock-toast")}
                    onClick={ handleOptionClicked }
                    >

                        <div className="d-flex justify-content-between">
                            <img onLoad={handleImageLoaded} src={props.settings.imageBaseUrl + props.optionModel.imageUrl + "?width=64&height=64&scale=both"} className={"product-image p-1"} alt={props.optionModel.productName}></img>
                            
                            <span style={{ backgroundColor: props.optionModel.tagColour, border: props.optionModel.tagColour + " 2px solid" }} className={"product-tag-container text-start px-2 "}>
                                <label className={"product-tag mb-0 " + textColour}>{props.optionModel.tagText}</label>
                            </span>
                        </div>
                        <div>
                            <h5 className={"product-name mt-1 mb-0 mt-sm-2 mb-sm-1 " + textColour}>{props.optionModel.productName}</h5>
                        </div>
                        <div className="mb-auto overflow-hidden">
                            <label className={"product-summary" + (props.optionModel.isSelected ? " text-muted-light" : " text-muted")}>
                                {
                                    props?.optionModel?.summaryList?.length > 0
                                    &&
                                        props.optionModel.summaryList.map((feature, index) =>
                                            <div key={"spanFeature_" + index}>
                                                {feature}
                                            </div>
                                        )
                                }
                            </label>
                        </div>
                        <div className="d-flex justify-content-between align-items-center mt-1 mt-sm-2">
                            <div>
                                <span className={"product-price " + textColour}>
                                    {
                                        props.optionModel.isSelected
                                        ?
                                            "Selected"
                                        :
                                            props.allowMultipleSelection
                                            ?
                                                <span>&pound;{Math.abs(props.optionModel.grossPrice).toFixed(2)}</span>
                                            :
                                                <span>{priceDifferenceSign} &pound;{Math.abs(props.optionModel.grossPriceDifference).toFixed(2)}</span>
                                    }
                                </span>
                            </div>

                            <span className={"position-relative text-end text-muted " + textColour}>
                                <span>Info</span>
                                <button className={"position-relative bg-transparent border-0 text-muted " + textColour} type="button"
                                    data-bs-toggle="offcanvas" data-bs-target={"#offcanvasProduct_" + props.optionModel.optionProductID} aria-controls={"#offcanvasProduct_" + props.optionModel.optionProductID}
                                    onClick={handleInfoClicked}
                                >
                                    <FontAwesomeIcon icon={icon({ name: 'circle-info', style: 'solid' })} />
                                </button>
                            </span>
                        </div>

                    </div>
            }

            <div ref={offcanvasElementRef} className="offcanvas offcanvas-end" tabIndex="-1" id={"offcanvasProduct_" + props.optionModel.optionProductID} aria-labelledby={"offcanvasProductLabel_" + props.optionModel.optionProductID} >
                <div className="offcanvas-header p-3 pb-2 p-md-5 pb-md-3">
                    <div>
                        <h1 className="offcanvas-title mb-2 me-2 me-sm-3 custom-color-light" id={"offcanvasProductLabel_" + props.optionModel.optionProductID}>{props.optionModel.productName}</h1>
                        <h4 className="text-muted fw-light mb-0">{priceDifferenceSign} &pound;{Math.abs(props.optionModel.grossPriceDifference).toFixed(2)}</h4>
                    </div>
                    <button ref={offcanvasCloseBtnRef} type="button" className="offcanvas-close-button btn-close me-1" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                    <button ref={hiddenOffcanvasCloseBtnRef} type="button" className="d-none offcanvas-close-button btn-close me-1" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>
                <div ref={offcanvasBodyRef} className="offcanvas-body d-flex flex-column pt-2 px-3 px-md-5 pb-5">

                    {
                        props.isIncompatible
                        &&
                            <Alert variant="danger" className="mb-4">
                                <Alert.Heading className="fw-bold">Incompatibility Detected</Alert.Heading>
                                <p className="mb-0">
                                    This component is not compatible with one or more other components in your build. For more information, please try adding this component to your build.
                                </p>
                            </Alert>
                    }

                    {
                        props.optionModel.description
                        &&
                            <p className="offcanvas-product-description mb-3">
                                {props.optionModel.description}
                            </p>
                    }

                    { 
                        productSpecModel?.product?.images?.length > 0
                        &&
                            <Carousel images={productSpecModel.product.images} imageBaseUrl={props.settings.imageBaseUrl} productName={props.optionModel.productName}></Carousel>
                    }

                    <button ref={atbBtnRef} className="atb-button primary-button px-5 mt-4 mx-auto w-100 text-casing custom-color-dark" data-bs-dismiss="offcanvas" type="button" disabled={props.isDisabled}
                        onClick={() => { props.handleOptionSelected(props.optionModel.optionProductID, props.optionModel.selectedQuantity, false, true); }}
                    >Add to Build</button>

                    <div className="d-flex flex-column mt-3">

                        {
                            productSpecModel?.specifications?.length > 0
                            &&
                                productSpecModel.specifications.map((spec, index) =>
                                    <div key={"spanOffcanvasAttributeContainer_" + index} className="mb-3">
                                        <span key={"spanOffcanvasSpecName_" + index} className="offcanvas-attribute-text">{spec.name}: </span>
                                        <div key={"spanOffcanvasSpecValue_" + index} className="offcanvas-attribute-text fw-bold" dangerouslySetInnerHTML={{ __html: spec.value }}></div>
                                    </div>
                                )
                        }

                    </div>
                </div>
            </div>
        </div>
    );

}
